<template>
  <v-app>
    <v-main>
      <v-container class="page-401">
        <v-img :src="logo" />
        <p class="mt-4 mb-1">Bạn không có quyền truy cập trang này.</p>
        <button class="page-401__button red--text" @click="logout">
          Đăng nhập với tài khoản khác.
        </button>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import logo from "@/assets/logo.jpg";
import Auth from "@/models/auth";

export default {
  name: "Page401",

  data() {
    return {
      logo: logo
    };
  },

  methods: {
    logout: () => {
      Auth.logout();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-401 {
  width: 350px;
  text-align: center;
}

.page-401__button {
  font-style: italic;

  &:hover {
    text-decoration: underline;
  }
}
</style>